import { Link } from "react-router-dom";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useTableResponsive } from "../../../hooks/useTableResponsive";
import PdfZipItem from "../../../components/PdfZipItem";
import { convertStringToArray } from "../../../Utils/utils";

const SwachhBharatTable = ({ tableData }) => {
  const { getText } = useLanguageTranslation();
  useTableResponsive(tableData);
  const newTableData = tableData?.map((item) => ({
    ...item,
    pdfFiles: convertStringToArray(item.field_download),
  }));

  return (
    <>
      <div className="title-sec">
        <h2>
          {getText(
            "Fulfilling The Cleanliness Pledge",
            "स्वच्छता संकल्प को पूरा करना"
          )}
        </h2>
      </div>

      <div className="table-responsive mb-5">
        <table className="table table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Title", "शीर्षक")}</th>
              <th>{getText("Detail", "विवरण")}</th>
            </tr>
          </thead>
          <tbody>
            {newTableData?.map((item, index) => (
              <tr key={index}>
                <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                <td data-key={getText("Title", "शीर्षक")}>{item.title}</td>
                <td data-key={getText("Detail", "विवरण")}>
                  {item.field_download ? (
                    <div className="d-flex">
                      {item.pdfFiles.map((item, i) => (
                        <PdfZipItem
                          key={i}
                          filePath={item?.file_path}
                          // filesize={item?.file_path}
                        />
                      ))}
                    </div>
                  ) : (
                    <>
                      <Link
                        to={`/sustainable-development/swachh-bharat-abhiyan-table/${item.nid}`}
                        className="division-pdf-icon"
                      >
                        <span className="date">
                          {getText("Details", "विवरण")}
                        </span>
                      </Link>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default SwachhBharatTable;
